import React, { createContext, useEffect, useState } from "react";
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const response = await axios.get("/api/public/api/me", { withCredentials: true });
      setAuthUser(response.data);
    } catch (error) {
      setAuthUser(null);
      if (error.response?.status === 401) {
        console.warn("Token expirado ou inválido");
      } else {
        console.error("Erro inesperado ao buscar usuário:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await axios.post("/api/public/api/logout", {}, { withCredentials: true });
    } catch (err) {
      console.error("Erro ao fazer logout:", err);
    } finally {
      setAuthUser(null);
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider
      value={{ authUser, setAuthUser, fetchUser, logout, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
};
